import { NodeRenderer } from '@contentful/rich-text-react-renderer';
import VideoRender from '../video-render/video-render';
import ImageRender from '../image-render/image-render';
import FormattedCode from '../formatted-code/formatted-code';
import TestimonialRender from '../testimonial-render/testimonial-render';

/* eslint-disable-next-line */
export interface EmbeddedEntryProps {}

export const EmbeddedEntry = (({ data: { target } }) => {
    const { sys, fields } = target;
    if (!sys.contentType) return null;
    const { id: contentType } = sys.contentType.sys;

    if (contentType === 'codeBlock') {
        return (
            <div className="max-w-2xl w-full mx-auto max-w-container embedded">
                <FormattedCode language={fields.language} code={fields.code} />
            </div>
        );
    }

    if (contentType === 'blockClientTestimonial') {
        return (
            <div className="max-w-2xl mx-auto container-rich-text embedded">
                <TestimonialRender
                    author={fields.authorName}
                    title={fields.authorTitle}
                    organization={fields.client?.fields?.name}
                    quote={fields.quote}
                />
            </div>
        );
    }

    if (contentType === 'imageWrapper' && fields.cloudinaryMedia) {
        return (
            <ImageRender
                fields={{
                    title: fields.altText ? fields.altText : fields?.title,
                    image: {
                        fields: {
                            file: { url: fields.cloudinaryMedia[0].public_id },
                            description: fields.description,
                        },
                    },
                }}
            />
        );
    }

    const isYoutubeVideo = sys.contentType.sys.id === 'video';
    if (isYoutubeVideo) {
        return <VideoRender title={fields?.title} url={fields?.url} />;
    }
    return null;
}) as NodeRenderer;

export default EmbeddedEntry;
